import React from 'react';

import * as localizationKeys from '../../../consts/localization/localizationKeys';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import {LeviaIcon} from '../../Icons';

const LeviaFwuNewFeatures = (props) => {
    const {
        titleKey = localizationKeys.FIRMWARE_MODAL_VIEW_FEATURES_LIST_TITLE,
        subTitleKey = localizationKeys.FIRMWARE_MODAL_VIEW_FEATURE_TITLE_1,
        descriptionKey = localizationKeys.FIRMWARE_MODAL_VIEW_FEATURE_DESCRIPTION_1,
    } = props;
    const localizedStrings = getLocalizedStrings();

    return (
        <>
            <p className='mt-8 text-20 font-bold'>{localizedStrings[titleKey]}</p>
            <ul className='mx-auto mt-6 flex max-w-[312px] flex-col items-center md:mt-4'>
                <li className='flex items-start gap-4'>
                    <LeviaIcon className='shrink-0' />
                    <div className='flex flex-col items-start gap-1 text-start'>
                        <div className='font-bold'>{localizedStrings[subTitleKey]}</div>
                        <p>{localizedStrings[descriptionKey]}</p>
                    </div>
                </li>
            </ul>
        </>
    );
};

export default LeviaFwuNewFeatures;
